import React from "react";
import SettingsSidebar, { SettingsSidebarItem } from "../../Layouts/MainPage/SettigsSideBar";
import Navbar from "../../Layouts/MainPage/Navbar";
import { Outlet, useLocation } from "react-router-dom";
import { GetAccess } from "../../Components/Utils/roles";
import { useTranslation } from "react-i18next";
import { BadgeCheck, BellDot, BookOpenCheck, Building2, ChevronDownSquare, ClipboardCheck, Contact, FileSliders, FireExtinguisher, Hammer, ListTodo, MailPlus, ReceiptText, ServerCog, ShieldUser, SquareCheckBig, SquareKanban, ToggleRight, UserCog, UserPlus, UserRoundCheck, Users } from "lucide-react";

const MainSettings = () => {
  const location = useLocation();

  const {t} = useTranslation();
  const navItem = [
    {
      icon: <Building2 size={16} />,
      title: "Company Info",
      link:'/settings',
      hasAccess:"company_info_view"

    },
    {
      icon: <Users size={16} />,
      title: "Client Management",
      link:`/settings/client-management`,
      hasAccess:"client_management_view"

    },
    {
      icon: <ClipboardCheck size={16} />,
      title: "Inspection",
      link:`/settings/inspection`,
      hasAccess:"inspection_view"

    },
    {
      icon: <BookOpenCheck size={16} />,
      title: "Commisioning",
      link:`/settings/commisioning`,
      hasAccess:"commisioning_view"

    },
    {
      icon: <FireExtinguisher size={16} />,
      title: "Refilling",
      link:`/settings/refilling`,
      hasAccess:"refilling_view"

    },
    {
      icon: <SquareKanban size={16} />,
      title: "Tickets",
      link:`/settings/tickets`,
      hasAccess:"tickets_view"

    },
    {
      icon: <ReceiptText size={16} />,
      title: "Invoice",
      link:`/settings/invoice`,
      hasAccess:"invoice_view"

    },
    {
      icon: <ListTodo size={16} />,
      title: "Task",
      link:`/settings/task`,
      hasAccess:"task_view"

    },
    {
      icon: <Contact size={16} />,
      title: "Contacts",
      link:`/settings/contacts`,
      hasAccess:"contacts_view"

    },
    {
      icon: <Hammer size={16} />,
      title: "Equipments",
      link:`/settings/equiments`,
      hasAccess:"equiments_view"

    },
    {
      icon: <ShieldUser size={16} />,
      title: "Inspector",
      link:`/settings/inspector`,
      hasAccess:"inspector_view"

    },
   
    {
      icon: <UserCog size={16} />,
      title: "Role",
      link:'/settings/role',
      hasAccess:"role_view"
    },
    {
      icon: <UserPlus size={16} />,
      title: "User",
      link:'/settings/user',
      hasAccess:"user_view"
    },
   
    {
      icon: <UserRoundCheck size={16} />,
      title: "User Role",
      link:'/settings/user-role',
      hasAccess:"user_role_view"
    },
    {
      icon: <BellDot size={16} />,
      title: "Notifications",
      link:'/settings/notifications',
      hasAccess:"notification_view"
    },
   
    {
      icon: <FileSliders size={16} />,
      title: "Reference",
      link:'/settings/reffrence',
      hasAccess:"reference_view"
    },
    
    {
      icon: <SquareCheckBig size={16} />,
      title: "Approval Permission",
      link:'/settings/statuspermission',
      hasAccess:"reference_view"
    },
    {
      icon: <ServerCog size={16} />,
      title: "Email Server",
      link:'/settings/emailserverdetails',
      hasAccess:"reference_view"
    },
    {
      icon: <MailPlus size={16} />,
      title: "Template",
      link:'/settings/emailtemplate',
      hasAccess:"emailtemplate_view"
    },
    {
      icon: <BadgeCheck size={16} />,
      title: "Approval Status",
      link:'/settings/newApproval',
      hasAccess:"approval_status_view"
    },
    {
      icon: <ChevronDownSquare size={16} />,
      title: "Drop Downs",
      link:'/settings/dropDowns',
      hasAccess:"dropDowns_view"
    },
    {
      icon: <ToggleRight size={16} />,
      title: "Enable / Disable",
      link:'/settings/enableDisable',
      hasAccess:"enable_disable_view"
    },
    
  ];



  function isActiveFun(x){
    let actualPath = location.pathname
    let linkPath = ""
    if(x?.hasSubMenu){
      if(x?.subMenu){
         let y = x.subMenu[0].link;
         linkPath = y
      }
    }else{
      linkPath = x?.link;
    }
    if(actualPath == linkPath) {
      return true;
    }else{
      return false;
    } 
  }

  return (
    <div className=" w-full h-screen bg-slate-100 flex justify-start items-center overflow-hidden">
      <div className=" hidden w-16 z-[997] lg:block">
      <SettingsSidebar>
        {navItem &&
          navItem.map((item) => {
            return (
              <>
              {
                GetAccess(item?.hasAccess) && (
                  <SettingsSidebarItem
                  icon={item?.icon}
                  text={t(item?.title)}
                  hasSubMenu={item?.hasSubMenu}
                  subItem={item?.subMenu}
                  link={item?.link}
                  active={isActiveFun(item)}
                  //  alert = "test"
                />
                )
              }
              </>
            );
          })}
      </SettingsSidebar>
      </div>
      <div className=" w-full h-[100vh]  ">
        <div className=" w-full h-[59px] bg-white z-50 shadow-lg">
          <Navbar />
        </div>
        <div className=" w-full h-[calc(100vh-87px)]  overflow-y-auto">
          <Outlet />
        </div>
        {/* <div className=" w-full h-7 ">
          <p className=' font-semibold text-center text-s text-slate-400'>
            <a
             href="https://numota.in"
             target="_blank"
            >
              &#169;  numota
            </a>
            </p>
        </div> */}
      </div>
    </div>
  );
};

export default MainSettings;